import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Route } from 'react-router';
import { NavigationContainer } from '@react-navigation/native';
import { Layout } from './components/Layout';
import { RequestLogs } from './pages/RequestLogs';
import { Home } from './pages/Home';
import { Details } from './pages/Details';
import { TestResult } from './pages/TestResult';
import { Sender } from './pages/Sender';
import { Provider } from "react-redux";
import store from "./store";

//import AuthorizeRoute from './components/api-authorization/AuthorizeRoute';
//import ApiAuthorizationRoutes from './components/api-authorization/ApiAuthorizationRoutes';
//import { ApplicationPaths } from './components/api-authorization/ApiAuthorizationConstants';

import './custom.css'

// REF: https://github.com/AzureAD/microsoft-authentication-library-for-js/tree/dev/lib/msal-react

export default function App() {
  return (
    <Provider store={store}>
      <Layout>
        <NavigationContainer>
          <Route exact path='/' component={Home} />
          <Route exact path='/home' component={Home} />
          <Route path='/logs' component={RequestLogs} />
          <Route path='/details' component={Details} />
          <Route path='/testResult' component={TestResult} />
          <Route path='/sender' component={Sender} />
        </NavigationContainer>
      </Layout>
    </Provider>
  );
}



/*
export default class App extends Component {
  static displayName = App.name;

  render() {
    document.title = "ImmucertUI";

    if (this.props.history !== undefined) {
      this.props.history.push({
        pathname: '/home',
        state: { serverInstance: "Prod" }
      })
    }

    return (
      <Layout>
        <NavigationContainer>
          <Route exact path='/' component={Home} />
          <Route exact path='/home' component={Home} />
          <Route path='/logs' component={RequestLogs} />
          <Route path='/details' component={Details} />
          <Route path='/testResult' component={TestResult} />
          <Route path='/sender' component={Sender} />
        </NavigationContainer>
      </Layout>
    );
  }
}
*/